import React from "react";
import Finance from "../components/Finance";

const ReportsFinancePage = () => {
  return <Finance />;
};

export default ReportsFinancePage;
